// extracted by mini-css-extract-plugin
export default {"tariffWrapper":"Tariff_tariffWrapper__Epcv8"};